<template>
    <div>
       <!-- 收货地址填写 -->
       <van-dialog class="sign-dialog" v-model="addressShow" width="300px" :show-confirm-button="false">
            <div class="attractCode">
                <span style="font-size: 18px; font-weight: 550; color: #1ab4ec">填写收货地址</span>

                <van-form @submit="onSubmitAdress">
                    <van-field border v-model="addressinfo.user_name" name="用户名" placeholder="请输入姓名" />
                    <van-field border v-model="addressinfo.user_mobile" maxlength="11" name="手机号" placeholder="请输入手机号" />
                    <van-field readonly clickable v-model="addressi.area" name="area" :value="value" placeholder="请选择地区" @click="AdressAreaShow = true" />
                    <van-field border v-model="addressi.areaDeatail" name="地址" placeholder="请输入详细地址" />
                    <van-button
                        native-type="submit"
                        style="margin-top: 16px; background-color: #1ea0d9; color: #fff; height: 25px; width: 75px; line-height: 25px"
                        >提交</van-button
                    >
                </van-form>
                <div class="delButton" @click="closeAddress"><van-icon name="cross" color="#bbb" /></div>
            </div>
        </van-dialog>
        <!-- 地区弹窗 -->
        <van-popup v-model="AdressAreaShow" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirmAddress" @cancel="AdressAreaShow = false" />
        </van-popup>

    </div>
</template>

<script>
import * as api from "@/api/live";
import { checkMobile, checkName } from "@/utils/utils.js";
import { areaList } from "@vant/area-data";
    export default {
      
        data(){
            return {
                AdressAreaShow:false,
                areaList,
                addressinfo: {
                    user_name: "",
                    user_mobile: "",
                },
                addressi: {
                    area: "",
                    areaDeatail: "",
                },
                value:''
            }
        },
        props:{
            addressShow:{
                type:Boolean,
                default:false
            },
			
            lotteryinfo:{
                type:Object,
                default(){
                    return {}
                }
            },
			live_id:{
                type: [String, Number],
			    default: "",
            },
            userId:{
                type: [String, Number],
			    default: "",
            }
        
        },
        mounted(){
            
        },
        methods:{
			closeAddress(){
				this.$emit('update:addressShow',false)
                this.addressinfo = {
                    user_name: "",
                    user_mobile: "",
                };
                this.addressi = {
                    area: "",
                    areaDeatail: "",
                };
			},
			onConfirmAddress(values) {
                this.addressi.area = values
                    .filter((item) => !!item)
                    .map((item) => item.name)
                    .join("");
                this.AdressAreaShow = false;
            },
			//提交收货地址
            onSubmitAdress() {
                if (this.addressinfo.user_name == "") {
                    this.$toast({
                        message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写姓名</div>',
                        type: "html",
                    });
                    return;
                }
                // if (this.addressinfo.user_name != "" && !checkName(this.addressinfo.user_name)) {
                //     this.$toast({
                //         message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写2-6位汉字姓名</div>',
                //         type: "html",
                //     });
                //     return;
                // }
                if (this.addressinfo.user_mobile == "") {
                    this.$toast({
                        message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写手机号</div>',
                        type: "html",
                    });
                    return;
                }
                if (this.addressinfo.user_mobile != "" && !checkMobile(this.addressinfo.user_mobile)) {
                    this.$toast({
                        message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写正确手机号</div>',
                        type: "html",
                    });
                    return;
                }
                if (this.addressi.area == "") {
                    this.$toast({
                        message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请选择地区</div>',
                        type: "html",
                    });
                    return;
                }
                if (this.addressi.areaDeatail == "") {
                    this.$toast({
                        message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写详细地址</div>',
                        type: "html",
                    });
                    return;
                }
                
                this.addressinfo.live_id = this.live_id;
                this.addressinfo.user_id = this.userId;
                this.addressinfo.lottery_id = this.lotteryinfo.id;
                this.addressinfo.user_address = this.addressi.area + this.addressi.areaDeatail;
                api.sendAddress(this.addressinfo).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">提交成功</div>',
                            type: "html",
                        });
                        this.$emit("fnaddressSubmit",this.addressinfo.user_mobile)
                        this.addressinfo = {
                            user_name: "",
                            user_mobile: "",
                            user_address: "",
                        };
                        this.addressi = {
                            area: "",
                            areaDeatail: "",
                        };
                
                    } else {
                        this.$toast(res.message);
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    @import "../assets/styles/dialogcommon.less";
    .van-field {
        width: 200px;
    }


</style>
